import { useMemo } from 'react';
import * as Components from 'components/layouts';

const PageBuilder = ({ components, pageId, type }) => {
	return useMemo(() => {
		return components?.length > 0
			? components.map((comp, key) => {
					let Comp = Components[comp.name];

					return (
						Comp && (
							<Comp
								key={key}
								type={type}
								pageId={pageId}
								first={(key === 0 && comp.name !== 'Hero') || (key === 1 && components[0].name === 'Hero' && components[1].name !== 'AbstractMouseEffect')}
								{...comp.data}
							/>
						)
					);
			  })
			: null;
	}, [components]);
};

export default PageBuilder;
